import { RouteConfig } from 'vue-router';
import NotFound from '@/core/pages/NotFound.vue';
import { LoanRoutes } from '@/loan/routing/loan-routes';
import { ProfileRoutes } from '@/profile/routing/profile-routes';
import { LoginRoutes } from '@/login/routing/login-routes';

export const routes: RouteConfig[] = [
	...LoanRoutes,
	...ProfileRoutes,
	...LoginRoutes,
	{
		path: '/not-found',
		name: 'NotFound',
		component: NotFound,
	},
	{
		path: '*',
		redirect: {
			name: 'NotFound',
		},
	},
];
